module.exports = __webpack_public_path__ + "static/media/intercom1.0ecd99f0.png";